import React from "react";

import NoData from "../assets/images/no-data.avif";
import { Button } from "@mui/material";

const EmptyListUi = ({ text, buttonLabel, onClick = () => {} }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        textAlign: "center",
        padding: "1rem",
      }}
    >
      <img
        src={NoData}
        alt="Empty"
        style={{
          height: "160px",
          objectFit: "contain",
          borderRadius: '16px'
        }}
      />
      <p
        style={{ fontSize: "1.125rem", color: "#4B5563", marginBottom: "1rem" }}
      >
        {text}
      </p>
      {buttonLabel && (
        <Button
          onClick={onClick}
         variant="outlined"
        >
          {buttonLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyListUi;
